import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useClusterStore } from '../stores/clusterStore';
import { getDashboardSummary } from '../lib/api';
import { ACCENT } from '../styles/tokens';
import { OverviewPage } from '../components/overview/OverviewPage';

export default function OverviewRoute() {
  const slug = useClusterStore(s => s.activeSlug);
  const stackFilter = useClusterStore(s => s.stackFilter);
  const stack = slug === 'all' ? stackFilter : '';

  const query = useQuery({
    queryKey: ['dashboard', slug, stack],
    queryFn: () => getDashboardSummary(slug, stack),
    refetchInterval: 30_000,
    placeholderData: keepPreviousData,
  });

  return (
    <OverviewPage
      data={query.data}
      slug={slug}
      accent={ACCENT}
      loading={query.isLoading}
      error={query.error}
    />
  );
}
